import { render, staticRenderFns } from "./Music.vue?vue&type=template&id=9f726ff8&scoped=true"
import script from "./Music.vue?vue&type=script&lang=js"
export * from "./Music.vue?vue&type=script&lang=js"
import style0 from "./Music.vue?vue&type=style&index=0&id=9f726ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f726ff8",
  null
  
)

export default component.exports